/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfPatientArchive } from '../../models/data-page-of-patient-archive';

export interface PatientArchiveSearch$Params {
  searchText?: string | null;
  dob?: string | null;
  mrn?: string | null;
  pageNumber?: number;
  SortByColumn?: string | null;
  SortByDirection?: string | null;
}

export function patientArchiveSearch(http: HttpClient, rootUrl: string, params?: PatientArchiveSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatientArchive>> {
  const rb = new RequestBuilder(rootUrl, patientArchiveSearch.PATH, 'get');
  if (params) {
    rb.query('searchText', params.searchText, {});
    rb.query('dob', params.dob, {});
    rb.query('mrn', params.mrn, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('SortByColumn', params.SortByColumn, {});
    rb.query('SortByDirection', params.SortByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfPatientArchive>;
    })
  );
}

patientArchiveSearch.PATH = '/api/PatientArchive/patientarchive/Search';
